<template>
    <div>
        <h1 style="font-size: 24px; color: black;">锁屏启动管理</h1>
        <el-card class="form-container" shadow="never">
            <el-input v-model="queryData.name" style="width: 200px" clearable placeholder="请输入"></el-input>
            <el-button  type="primary" @click="query()">查询</el-button>
            <el-button class="sub-sub" type="primary" @click="showDetails('新增应用')">新增</el-button>
        </el-card>
        <h1>
            <el-table :data="appLinks"
                      border
                      :fit="true">
                <el-table-column label="应用ID" prop="id" align="center"></el-table-column>
                <el-table-column label="应用名称" prop="name" align="center"></el-table-column>
                <el-table-column label="详细" prop="detail" align="center"></el-table-column>
                <el-table-column label="跳转链接" prop="widgetScheme" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column  label="应用图片" width="120px" align="center">
                    <template slot-scope="scope">
                        <template>
                            <img :src="VUE_APP_CDN_URL+scope.row.image" width="60px" height="60px" />
                        </template>
                    </template>
                </el-table-column>
                <el-table-column  label="线性图标" width="120px" align="center">
                    <template slot-scope="scope">
                        <template>
                            <img :src="VUE_APP_CDN_URL+scope.row.imageLine" width="60px" height="60px" />
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="showDetails('编辑应用',scope.row)">编辑</el-button>
                        <el-button type="text" @click="remove(scope.row.id)">删除</el-button>
                        <el-button type="text" @click="showIcons('关联图标',scope.row)">关联图标</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </h1>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[10,20,30]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
        </el-pagination>
        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="600px">
            <el-form :model="addAppLinkForm">
                <el-form-item label="应用名称 :" :label-width="labelWidth">
                    <el-input  type="text" v-model="addAppLinkForm.name" maxlength="50" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="详细 :" :label-width="labelWidth">
                    <el-input  type="text" v-model="addAppLinkForm.detail" ></el-input>
                </el-form-item>
                <el-form-item label="跳转链接 :" :label-width="labelWidth">
                    <el-input  type="text" v-model="addAppLinkForm.widgetScheme" ></el-input>
                </el-form-item>
                <el-form-item label="应用图片 :" :label-width="labelWidth">
                    <el-upload
                            :headers="headers"
                            class="avatar-uploader"
                            :action="uploadURL"
                            :show-file-list="false"
                            :on-success="handleImageSuccess"
                            :before-upload="function (file) { return beforeAvatarUpload(file)}"
                            @click="uploadImage">
                        <img v-if="addAppLinkForm.image" :src="VUE_APP_CDN_URL+addAppLinkForm.image" class="avatar">
                        <i v-else class="el-icon-picture avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="线性图标:" :label-width="labelWidth">
                    <el-upload
                            :headers="headers"
                            class="avatar-uploader"
                            :action="uploadURL"
                            :show-file-list="false"
                            :on-success="handleImageLineSuccess"
                            :before-upload="function (file) { return beforeAvatarUpload(file)}"
                            @click="uploadImage">
                        <img v-if="addAppLinkForm.imageLine" :src="VUE_APP_CDN_URL+addAppLinkForm.imageLine" class="avatar">
                        <i v-else class="el-icon-picture avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>

                <div style="text-align: center;">
                    <el-button type="primary" @click="confirmForm" >提 交</el-button>
                    <el-button type="info" @click="dialogVisible=false">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>
        <el-dialog :title="dialogIconTitle" center :visible.sync="dialogIconVisible" width="1234px" :before-close="cancel" :destroy-on-close="true">
            <el-table border
                      ref="multipleTable"
                      :data="icons"
                      tooltip-effect="dark"
                      style="width: 100%"
                      @selection-change="handleSelectionChange"
                      stripe
                      :row-key="getRowKeys"
                      :row-class-name="gameRowTableClass">
                <el-table-column
                        type="selection"
                        :reserve-selection="true"
                        width="55">
                </el-table-column>
                <el-table-column label="图标ID" prop="id" align="center"></el-table-column>
                <el-table-column  label="icon图片"  align="center">
                    <template slot-scope="scope">
                        <template>
                            <img :src="VUE_APP_CDN_URL+scope.row.image" width="60px" height="60px" />
                        </template>
                    </template>
                </el-table-column>
            </el-table>

            <h1 style="text-align: center;">
                <el-button type="primary" @click="confirm">确 定</el-button>
                <el-button type="info" @click="cancel">取 消</el-button>
            </h1>

        </el-dialog>
    </div>
</template>

<script>
    import {
        icons,
        upload,
        saveAppLink,
        deleteAppLink,
        saveAppLinkIconRel,
        findAppLinkIconRel,
        searchAppLink
    } from "@/http/iosApi";
    export default {
        name: "AppLink",
        data(){
            return{
                VUE_APP_IOS_URL:'',
                VUE_APP_CDN_URL:'',
                headers:{},
                dialogVisible:false,
                dialogTitle:'',
                dialogIconTitle :'',
                dialogIconVisible:false,
                uploadURL: process.env.VUE_APP_IOS_URL + "block/upload",
                appLinks:[],
                labelWidth: '110px',
                addAppLinkForm: {
                    id: 0,
                    name: '',
                    widgetScheme:'',
                    image:'',
                    detail:'',
                    imageLine:''
                },
                selectForm:{},
                multipleSelection: [],
                selectList:[],
                iconSelectors :{},
                icons:[],
                queryData:{},
                page: {
                    size: 10,
                    page: 1,
                    totalElements: null
                },
            }
        },
        methods:{
            showDetails(title,data){
                if (data){
                    this.addAppLinkForm= {
                        id: data.id,
                        name: data.name,
                        widgetScheme: data.widgetScheme,
                        image: data.image,
                        detail:data.detail,
                        imageLine:data.imageLine
                    }
                }else {
                    this.addAppLinkForm= {
                        id: 0,
                        name: '',
                        widgetScheme:'',
                        image:'',
                        detail:'',
                        imageLine:''
                    }
                }
                this.dialogTitle  = title;
                this.dialogVisible = true;
            },
            iconList(){
                this.$nextTick(()=>{
                        icons().then(resp => {
                            this.icons = resp.data.info;
                            this.selectList.forEach(item => {
                                this.$refs.multipleTable && this.$refs.multipleTable.toggleRowSelection(item.icon, true)
                            })
                        })
                    }
                )

            },
            async showIcons(title,row){
                this.dialogIconTitle = title;
                this.dialogIconVisible = true;
                this.iconSelectors.appLinkId = row.id;
                await this.queryList();
                await this.iconList();

            },
            queryList(){
                return new Promise(resolve => {
                    findAppLinkIconRel(this.iconSelectors.appLinkId).then(resp => {
                        this.selectList = resp.data.info;
                        resolve();
                        return;
                    })
                })
            },
            getRowKeys(row){
                return row.id
            },
            gameRowTableClass({row,rowIndex}){
                row.index=rowIndex
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            uploadImage(){
                let func = upload;
                func().then().catch(function () {
                })
            },
            clear(){
                this.$refs.multipleTable.clearSelection();
            },
            confirm(){
                let iconIds =[];
                this.multipleSelection.forEach(item =>{
                    iconIds.push(item.id)
                });
                this.iconSelectors.iconIds = iconIds;
                let _message = '';
                if(this.iconSelectors.iconIds === '' || this.iconSelectors.iconIds.length<1){
                    _message = '请勾选图标'
                }
                if(_message){
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
                saveAppLinkIconRel(this.iconSelectors).then(resp=> {
                    if (resp.data.status===0){
                        this.dialogIconVisible=false;
                    }
                });
            },
            cancel(){
                this.clear();
                this.dialogIconVisible=false;
            },
            handleImageSuccess(response){
                this.addAppLinkForm.image=response.info;
            },
            handleImageLineSuccess(response){
                this.addAppLinkForm.imageLine=response.info;
            },
            remove(id){
                this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteAppLink(id).then(resp=> {
                        if (resp.data.status === 0) {
                            this.search();
                        }
                    });
                }).catch(() => {
                })
            },
            beforeAvatarUpload(file) {
                const isIcon = file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg'|| file.type === 'image/gif';
                const isLt2M = file.size / 1024 / 1024 < 1;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过1MB!');
                }
                if (!isIcon) {
                    this.$message.error('上传图片只能是png,jgp,jpeg格式!');
                }
                return isIcon && isLt2M;
            },
            confirmForm(){
                let _message = '';
                if(this.addAppLinkForm.name===''){
                    _message = '请输入应用名称'
                }else if (this.addAppLinkForm.widgetScheme===''){
                    _message = '请输入跳转链接'
                }else if (this.addAppLinkForm.image===''){
                    _message = '请上传图片'
                }
                if(_message){
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
                saveAppLink(this.addAppLinkForm).then(resp => {
                    if (resp.data.status === 0 ){
                        this.search();
                        this.dialogVisible = false;
                    }
                });
            },
            search(){
                this.queryData.size = this.page.size;
                this.queryData.page = this.page.page;
                searchAppLink(this.queryData).then(resp=>{
                    this.appLinks = resp.data.info.content;
                    this.page.totalElements = resp.data.info.totalElements
                })
            },
            query(){
                this.queryData.size = this.page.size;
                this.queryData.page = 1;
                searchAppLink(this.queryData).then(resp=>{
                    this.appLinks = resp.data.info.content;
                    this.page.totalElements = resp.data.info.totalElements
                })
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.search();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.search();
            },
        },
        created() {
            this.headers ={Authorization : this.$store.state.user.token};
            this.search();
            findAppLinkIconRel(23).then(resp => {
                console.log(resp.data.info)
            })
        },
        mounted() {
            this.VUE_APP_IOS_URL=process.env.VUE_APP_IOS_URL;
            this.VUE_APP_CDN_URL= process.env.VUE_APP_CDN_URL;
        }
    }
</script>

<style scoped>

</style>